import React, { Component, useState, Fragment, useEffect, useRef, useMemo } from 'react';
import { withStyles } from "@material-ui/core/styles";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import HomeIcon from '@mui/icons-material/Home';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import GrainIcon from '@mui/icons-material/Grain';
import LightModeIcon from '@mui/icons-material/LightMode';
import Checkbox from '@mui/material/Checkbox';
import ClearIcon from '@material-ui/icons/Clear';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { AppBar, Toolbar, Typography, Button, IconButton, Modal, Grid, Box, TextField, FormControl, Drawer, Menu, Paper, Select, MenuItem, TableFooter, TableRow, TableCell } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import Card from '@material-ui/core/Card';
import SearchIcon from '@material-ui/icons/Search';
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import EditIcon from '@mui/icons-material/Edit';
import { PostAddOutlined } from '@mui/icons-material';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@material-ui/icons/Visibility';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { customTheme, getColorfont, getColor } from '../../../StyleComponents/Styledatatable';
import classNames from 'classnames';
import ApprovalIcon from '@mui/icons-material/Approval';
import FilterListIcon from '@mui/icons-material/FilterAlt';
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import useStyles from '../../../StyleComponents/StyleFunctionComponent';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Skeleton from '@material-ui/lab/Skeleton';
import LinearProgress from '@mui/material/LinearProgress';
import { API_BASE_URL, token, userLevel, adminId } from '../../../../constants';

const Mechcallingstatreport = () => {
    const history = useHistory();
    const [openSidebar, setOpenSidebar] = useState(false);
    const [filterText, setFilterText] = useState("");
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [perPage, setPerPage] = useState(50);
    const [page, setPage] = useState(0);
    const [search, setSearch] = useState('');
    const [totalCount, setTotalCount] = useState(0);
    const currentDate = new Date();
    const sevenDaysAgo = new Date(currentDate);
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 5);
    const [fromDate, setFromDate] = useState(sevenDaysAgo.toISOString().split('T')[0]);
    const [toDate, setToDate] = useState(currentDate.toISOString().split('T')[0]);
    const [enquirySource, setEnquirySource] = useState([]);
    const [selectedState, setSelectedState] = useState();
    const [stateOptions, setStateOptions] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState();
    const [brandOptions, setBrandOptions] = useState([]);
    const [selectedExecutiveId, setSelectedExecutiveId] = useState(null);
    const [executiveOptions, setExecutiveOptions] = useState([]);
    const [sources, setSources] = useState([]);
    const [selectedSource, setSelectedSource] = useState();
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/webApi/sources`);

                const data = response.data.data;
                setSources(data.map(item => item.enquiry_from));
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    const handleSelectChange = (event) => {
        setSelectedSource(event.target.value);
    };

    useEffect(() => {
        const fetchDatabrand = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity,
                };
                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/brand-list`, config);
                const statelist = response.data.data.map(item => ({
                    id: item.brand_id,
                    title: item.brand_name,
                }));
                setBrandOptions(statelist);
            } catch (error) {
                console.error('Error fetching state:', error);
            }
        };
        fetchDatabrand();
    }, []);

    useEffect(() => {
        const fetchDatastate = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity,
                };
                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/state-list`, config);
                const statelist = response.data.data.map(item => ({
                    id: item.state_id,
                    title: item.state_name,
                }));
                setStateOptions(statelist);
            } catch (error) {
                console.error('Error fetching state:', error);
            }
        };
        fetchDatastate();
    }, []);
    useEffect(() => {
        const fetchDatalist = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity,
                };
                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/executive-list`, config);
                const mappedData = response.data.data.map(item => ({
                    id: item.admin_id,
                    title: item.username,
                }));
                setExecutiveOptions(mappedData);
            } catch (error) {
                console.error('Error fetching executives:', error);
            }
        };
        fetchDatalist();
    }, []);
    const handleExecutiveChange = (event) => {
        const selectedId = event.target.value;
        setSelectedExecutiveId(selectedId);
    };
    const handleStateChange = (event, newValue) => {
        setSelectedState(newValue);
    };
    const handleBrandChange = (event, newValue) => {
        setSelectedBrand(newValue);
    };
    const fetchData = async () => {
        setIsLoading(true);
        setError(null);

        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `${token}`,
                    "adminId": `${adminId}`,
                    "userLevel": `${userLevel}`,
                },
                timeout: Infinity,
            };

            const requestData = {
                start_date: fromDate,
                end_date: toDate,
                page: page + 1,
                pagination: perPage,
            };

            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/crm-executive-report`,
                requestData,
                config
            );

            const apiData = response.data.data;

            const mappedData = apiData.data.map((item, index) => ({
                sn: index + 1 + (page * perPage),
                admin_id: item.admin_id,
                name: item.name,
                total_calls: item.total_calls,
                connected_calls: item.connected_calls,
                not_connected_calls: item.not_connected_calls,
                interested: `${item.interested?.count || 0} (${item.interested?.percentage || 0}%)`,

                call_later: `${item.call_later?.count || 0} (${item.call_later?.percentage || 0}%)`,
                already_purchased: `${item.already_purchased?.count || 0} (${item.already_purchased?.percentage || 0}%)`,
                not_interested: `${item.not_interested?.count || 0} (${item.not_interested?.percentage || 0}%)`,
                old: `${item.old?.count || 0} (${item.old?.percentage || 0}%)`,
                ringing_no_response: `${item.ringing_no_response?.count || 0} (${item.ringing_no_response?.percentage || 0}%)`,
                busy: `${item.busy?.count || 0} (${item.busy?.percentage || 0}%)`,
                switched_off: `${item.switched_off?.count || 0} (${item.switched_off?.percentage || 0}%)`,
                invalid_number: `${item.invalid_number?.count || 0} (${item.invalid_number?.percentage || 0}%)`,
                language_problem: `${item.language_problem?.count || 0} (${item.language_problem?.percentage || 0}%)`,
                other: `${item.other?.count || 0} (${item.other?.percentage || 0}%)`,
                no_incoming: `${item.no_incoming?.count || 0} (${item.no_incoming?.percentage || 0}%)`,
            }));

            setData(mappedData);
            setTotalCount(apiData.total);

            setSnackbarMessage("Data fetched successfully");
            setSnackbarOpen(true);

        } catch (error) {
            console.error(error);
            setError("Failed to fetch data");
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        fetchData();
    }, [page, perPage]);

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        if (name === 'fromDate') {
            setFromDate(value);
        } else if (name === 'toDate') {
            setToDate(value);
        }
    };

    const handlePerPageChange = (e) => {
        setPerPage(Number(e.target.value));
    };

    const handlePrevious = () => {
        if (page > 0) {
            setPage(page - 1);
        }
    };

    const handleNext = () => {
        setPage(page + 1);
    };

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        setPage(0);
        fetchData();
        setOpenSidebar(false);
    };
    const clearForm = () => {
        setSelectedBrand(null);
        setSearch("");
        setPage(0);
        fetchData();
    };

    const columns = [
        {
            name: 'sn',
            label: 'S/N',
            options: {
                filter: true,
                setCellProps: () => ({
                    align: "center",
                }),

            },
        },
        {
            name: 'name', options: {
                filter: true,
                setCellProps: () => ({
                    align: "left",
                })
            },
            label: "Executive Name",
        },

        {
            name: "total_calls",
            label: "Total",

        },
        {
            name: "connected_calls",
            label: "Connected ",
        },

        {
            name: "not_connected_calls",
            label: "Not Connected ",
        },
        {
            name: "interested",
            label: "Interested",
        },

        {
            name: "call_later",
            label: "Call Later",
        },
        {
            name: "already_purchased",
            label: "Already Purchased",
        },
        {
            name: "old",
            label: "Old Tractor Enq.",
        },
        {
            name: "not_interested",
            label: "Not Interested",
        },
        {
            name: "ringing_no_response",
            label: "Not Response",
        },
        {
            name: "busy",
            label: "Status Busy",
        },

        {
            name: "switched_off",
            label: "Switched Off",
        },
        {
            name: "invalid_number",
            label: "Invalid Number",
        },
        {
            name: "language_problem",
            label: "Language Problem",
        },

        {
            name: "other",
            label: "Other",
        },
        {
            name: "no_incoming",
            label: "No Incoming",
        },

    ];
    const CustomToolbarAction = ({ toggleFilter }) => (
        <IconButton aria-label="Filter list" onClick={toggleFilter}>
            <FilterListIcon onClick={toggleSidebar} />
        </IconButton>
    );


    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.shiftKey && event.key === 'F') {
                // Shift + D is pressed, open the sidebar
                setOpenSidebar(true);
            }
        };

        window.addEventListener('keydown', handleKeyPress);

        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, []);

    const toggleSidebar = () => {
        setOpenSidebar(!openSidebar);
    };

    const footerTotals = useMemo(() => {
        return data.reduce(
            (acc, item) => {
                const getCount = (value) => {
                    if (!value) return 0;

                    // extract number before "("
                    const match = value.toString().match(/^(\d+)/);
                    return match ? Number(match[1]) : 0;
                };

                acc.total_calls += Number(item.total_calls || 0);
                acc.connected_calls += Number(item.connected_calls || 0);
                acc.not_connected_calls += Number(item.not_connected_calls || 0);

                acc.interested += getCount(item.interested);
                acc.call_later += getCount(item.call_later);
                acc.already_purchased += getCount(item.already_purchased);
                acc.old += getCount(item.old);
                acc.not_interested += getCount(item.not_interested);
                acc.ringing_no_response += getCount(item.ringing_no_response);
                acc.busy += getCount(item.busy);
                acc.switched_off += getCount(item.switched_off);
                acc.invalid_number += getCount(item.invalid_number);
                acc.language_problem += getCount(item.language_problem);
                acc.other += getCount(item.other);
                acc.no_incoming += getCount(item.no_incoming);

                return acc;
            },
            {
                total_calls: 0,
                connected_calls: 0,
                not_connected_calls: 0,
                interested: 0,
                call_later: 0,
                already_purchased: 0,
                old: 0,
                not_interested: 0,
                ringing_no_response: 0,
                busy: 0,
                switched_off: 0,
                invalid_number: 0,
                language_problem: 0,
                other: 0,
                no_incoming: 0,
            }
        );
    }, [data]);



    const options = {
        rowsPerPage: perPage,
        selectableRows: 'none',
        page: page,
        serverSide: true,
        count: totalCount,
        onTableChange: (action, tableState) => {
            switch (action) {
                case 'changePage':
                    setPage(tableState.page);
                    break;
                case 'changeRowsPerPage':
                    setPerPage(tableState.rowsPerPage);
                    setPage(0);
                    break;
                default:
                    break;
            }
        },

        customToolbar: () => <CustomToolbarAction />,
        filter: false,
        filterType: "dropdown",
        responsive: "standard",
        fixedHeader: true,
        fixedSelectColumn: true,
        overflowy: "auto",
        overflowx: "auto",
        rowsPerPageOptions: [10, 50, 100, 500, 1000, 10000, { value: totalCount, label: 'All' }],
        customFilterDialogFooter: (currentFilter, applyNewFilter) => (
            <div>
                <TextField
                    label="Filter Data"
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                    fullWidth
                />
                <Button onClick={applyNewFilter} variant="contained" color="primary">
                    Apply Filter
                </Button>
                <Button onClick={() => setOpenSidebar(false)} variant="contained" color="secondary">
                    Cancel
                </Button>
            </div>
        ),

        customTableBodyFooterRender: () => {
            return (
                <>
                    <TableFooter className={classes.footerCell} style={{ position: 'sticky', bottom: 0, backgroundColor: "#DDDDDD" }}>
                        <TableRow style={{ height: "20px" }}>
                            <TableCell style={{ color: "black", padding: "10px" }} className={classNames(classes.fontred, classes.muifooterfont)}>
                                Total
                            </TableCell>

                            <TableCell style={{ color: "black" }} className={classNames(classes.fontred, classes.muifooterfont)}>
                            </TableCell>

                            <TableCell style={{ color: "black" }} className={classNames(classes.fontred, classes.muifooterfont)}>
                                {footerTotals.total_calls}
                            </TableCell>

                            <TableCell style={{ color: "black" }} className={classNames(classes.fontred, classes.muifooterfont)}>
                                {footerTotals.connected_calls}
                            </TableCell>

                            <TableCell style={{ color: "black" }} className={classNames(classes.fontred, classes.muifooterfont)}>
                                {footerTotals.not_connected_calls}
                            </TableCell>

                            <TableCell style={{ color: "black" }} className={classNames(classes.fontred, classes.muifooterfont)}>
                                {footerTotals.interested}
                            </TableCell>

                            <TableCell style={{ color: "black" }} className={classNames(classes.fontred, classes.muifooterfont)}>
                                {footerTotals.call_later}
                            </TableCell>

                            <TableCell style={{ color: "black" }} className={classNames(classes.fontred, classes.muifooterfont)}>
                                {footerTotals.already_purchased}
                            </TableCell>

                            <TableCell style={{ color: "black" }} className={classNames(classes.fontred, classes.muifooterfont)}>
                                {footerTotals.old}
                            </TableCell>

                            <TableCell style={{ color: "black" }} className={classNames(classes.fontred, classes.muifooterfont)}>
                                {footerTotals.not_interested}
                            </TableCell>

                            <TableCell style={{ color: "black" }} className={classNames(classes.fontred, classes.muifooterfont)}>
                                {footerTotals.ringing_no_response}
                            </TableCell>

                            <TableCell style={{ color: "black" }} className={classNames(classes.fontred, classes.muifooterfont)}>
                                {footerTotals.busy}
                            </TableCell>

                            <TableCell style={{ color: "black" }} className={classNames(classes.fontred, classes.muifooterfont)}>
                                {footerTotals.switched_off}
                            </TableCell>

                            <TableCell style={{ color: "black" }} className={classNames(classes.fontred, classes.muifooterfont)}>
                                {footerTotals.invalid_number}
                            </TableCell>

                            <TableCell style={{ color: "black" }} className={classNames(classes.fontred, classes.muifooterfont)}>
                                {footerTotals.language_problem}
                            </TableCell>

                            <TableCell style={{ color: "black" }} className={classNames(classes.fontred, classes.muifooterfont)}>
                                {footerTotals.other}
                            </TableCell>

                            <TableCell style={{ color: "black" }} className={classNames(classes.fontred, classes.muifooterfont)}>
                                {footerTotals.no_incoming}
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                </>
            );
        }

    };


    const currentTheme = customTheme(true);
    const classes = useStyles();
    const memoizedData = useMemo(() => data, [data]);
    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    return (
        <>
            <div>
                {/* Your other components */}
                <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                    <MuiAlert onClose={handleCloseSnackbar} severity="info" sx={{ width: '100%' }}>
                        {snackbarMessage}
                    </MuiAlert>
                </Snackbar>
            </div>
            <Box sx={{ width: '100%' }}>
                <Typography className={classNames(classes.pagetittle, classes.pagetittlestyle)}>
                    CRM Executive wise Report
                </Typography>
                <hr className={classes.horizontalline} />
            </Box>

            <MuiThemeProvider theme={currentTheme}>
                {
                    isLoading ? (
                        <LinearProgress />

                    ) : (
                        ""
                    )
                }

                <MUIDataTable
                    title={
                        isLoading ? (
                            <Skeleton animation="wave" />

                        ) : (
                            <Typography className={classes.tabletittle} >
                                CRM Executive wise Report
                            </Typography>
                        )
                    }
                    data={memoizedData}
                    columns={columns}
                    options={options}
                />
            </MuiThemeProvider>
            <Drawer anchor="right" open={openSidebar}
                PaperProps={{
                    style: {
                        width: "100%",
                        maxWidth: 300,
                        padding: "10px"
                    }
                }}
                onClose={() => setOpenSidebar(false)}
            >
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={1}>
                        <Grid item xs={4} sm={2} lg={12} style={{ textAlign: "right", cursor: "pointer", }}>

                            <ClearIcon style={{ color: '#c0392b' }} onClick={() => setOpenSidebar(false)} />
                        </Grid>
                        <Grid item xs={4} sm={2} lg={12} >
                            <br />
                            <Typography className={classes.tabletittle} >
                                Filter
                            </Typography>
                        </Grid>
                    </Grid>
                    <div className={classes.root} style={{ paddingRight: "22px", paddingLeft: "22px" }}>
                        <div className={classes.root}>
                            <Grid container spacing={1}>

                                <Grid item xs={12} sm={12} lg={12} >
                                    <Autocomplete
                                        classes={{
                                            option: classes.autocompleteoption,
                                        }}
                                        // multiple 
                                        options={brandOptions}
                                        getOptionLabel={(option) => option.title}
                                        renderInput={(params) => (
                                            <TextField {...params} placeholder='Select brand' variant="outlined" />
                                        )}
                                        value={selectedBrand}
                                        onChange={handleBrandChange}
                                        disableCloseOnSelect
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        getOptionSelected={(option, value) => option.id === value.id}
                                        renderOption={(props, option, { selected }) => (
                                            <li {...props}>

                                                {option.title}
                                            </li>
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={4} sm={2} lg={12} >
                                    <input className={classes.inputform} type="date" name="fromDate" value={fromDate} onChange={handleDateChange} />

                                </Grid>

                                <Grid item xs={4} sm={2} lg={12}>
                                    <input className={classes.inputform} type="date" name="toDate" value={toDate} onChange={handleDateChange} />
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                    <br />
                    <Grid >
                        <Grid item xs={4} sm={2} lg={12} style={{ margin: "auto", padding: "auto", textAlign: "center" }}>
                            <Button
                                type='submit'
                                style={{ marginRight: "10px" }}
                                className={classes.buttonform}
                                variant="outlined" startIcon={<ApprovalIcon />}>
                                Apply
                            </Button>
                            <Button
                                type="button" onClick={clearForm}
                                style={{ backgroundColor: "#dc3545", borderColor: '#dc3545' }}
                                className={classes.buttonform}
                                variant="outlined" startIcon={<ClearIcon />}>
                                Clear
                            </Button>

                        </Grid>
                    </Grid>
                    <br />
                </form>
            </Drawer >

        </>
    );
};

export default Mechcallingstatreport;








